import {
  Avatar,
  AvatarGroup,
  AvatarGroupItem,
  AvatarGroupPopover,
  partitionAvatarGroupItems,
  Tooltip,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  SplitButton,
  Switch,
} from "@fluentui/react-components";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import useNavigation from "../../../utils/useNavigation";
import Button from "../../../components/controls/button/Button";
import Input from "../../../components/controls/input/customInput/CustomInput";
import Modal from "../../../components/controls/modal/Modal";
import Risk from "../../risk";
import ProjectDetails from "../detailedViews/details";
import { useDispatch } from "react-redux";
import InputUnderline from "../../../components/controls/input/InputUnderline";
import Searchable from "../../../components/controls/select/CustomSelect";
import Tabs from "../../../components/controls/tabs/Tabs";
import HoverCard from "../../../components/hoverCard/HoverCard";
import {
  CalendarIcon,
  ClipboardX,
  DeleteIcon,
  EditIcon,
  HealthKPIArrow,
  HealthKPISquare,
  PrintIcon,
} from "../../../modules/default-svg";
import portfolioService from "../../../store/services/portfolio.service";
import programService from "../../../store/services/programs.service";
import projectService from "../../../store/services/projects.service";
import { apiCall } from "../../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../../store/services/URL";
import service from "../../../store/services/user.service";
import {
  dateOnlyFormatted,
  getAccountCurrency,
  displayDecimalFormatted,
  weeksBetweenDates,
  isDateGreaterThan,
} from "../../../utils/systemSettings";
import AllocatedResources from "../../allocatedResources";
import Budget from "../../budget";
import ChangeRequest from "../../changeRequest";
import Communication from "../../communication";
import ScopeItem from "../../scopeItem";
import HealthStatus from "../healthStatus";
import Stakeholders from "../stakeholders";
import styles from "./Overview.module.scss";
import { getLabelByType, projectStatus, UserSearchRefType } from "../../../helpers/utils";
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import { ResourceMoniteringProvider } from "../../resourcePlanner/resourceMonitoring/ResourceContext";
import DashboardHeader from "../../dashboard/DashboardHeader";
import { generalActions } from "../../../store/actions";
import ContactsSelect from "../../../components/contactsSelect/ContactsSelect";
import Milestones from "../../milestone";
import deletionRequestService from "../../../store/services/deletionRequest.service";
import DeleteRequest from "../../../components/DeleteRequest/DeleteRequest";
import RichTextEditor from "../../../components/richTextEditor/RichTextEditor";
import Appendix from "../appendix/Appendix";
import CashFlow from "../../cashFlow/CashFlow";
import PurchaseOrders from "../../purchaseOrders";
import InvoiceRegistry from "../../invoiceRegistry";
import DecisionLog from "../../decisionLog";
import EntityFileUpload from "../../../components/controls/fileUpload/EntityFileUpload";
import {
  BudgetChart,
  ProjectProgress,
} from "../../../components/charts/DashboardCharts";
import Skeleton from "react-loading-skeleton";
import { ListChevronsDownUp, ListChevronsUpDown, Settings2 } from "lucide-react";
import { Spinner } from "react-bootstrap";
import { set } from "lodash";
import { useLocation } from "react-router-dom";
import { TAB_MAPPING } from "../../../helpers/utils";
import UserSelect from "../../../components/userSelect/UserSelect";
import ResourcesReport from "../../resourcesReport/ResourcesReport";
import { ParentType } from "../../resourcesReport/constants";
import { getDeletePermission, getEditPermission } from "../../../helpers/utils";

const ProjectOverview = (props) => {
  const {
    projectID,
    getProjectDetails,
    projectData,
    projectBudgetSummary,
    projectProgressSummary,
    updateProjectRequest,
    StatusReportRequest,
    clearReportRequest,
    getReport,
    getReportLoading,
    error,
    loading,
    overviewLoading,
    deleteRequest,
  } = props;
  const settings = JSON.parse(localStorage.getItem("settings"));
  const [setting] = useState(settings);
  const prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [data, setData] = useState({});
  const [name, setName] = useState("");
  const [type, setType] = useState(null);
  const [attachments, setAttachments] = useState([]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [revisedEndDate, setRevisedEndDate] = useState("");

  const [clients, setClients] = useState([]);
  const [portfolios, setPortfolios] = useState([]);
  const [programs, setPrograms] = useState([]);

  const [executive, setExecutive] = useState(null);
  const [executiveId, setExecutiveId] = useState("");
  const [sponsor, setSponsor] = useState(null);
  const [sponsorId, setSponsorId] = useState("");
  const [budget, setBudget] = useState(0);
  const [status, setStatus] = useState(0);
  const [refId, setRefId] = useState("");
  const [progress, setProgress] = useState(0);

  const [stakeholders, setStakeholders] = useState([]);
  const [stakeholdersIds, setStakeholdersIds] = useState("");
  const [description, setDescription] = useState("");

  const [deleteModal, setDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [showStatusReport, setShowStatusReport] = useState(false);
  const [pdfData, setPdfData] = useState("");
  const [selectedAppendix, setSelectedAppendix] = useState(null);

  const [manager, setManager] = useState(null);
  const [lead, setLead] = useState(null);
  const [client, setClient] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [program, setProgram] = useState("");

  const [currentGlobalHealth, setCurrentGlobalHealth] = useState(0);
  const [trendingGlobalHealth, setTrendingGlobalHealth] = useState(0);
  const [statusReportPeriod, setStatusReportPeriod] = useState("");
  const [budgetSummary, setBudgetSummary] = useState({
    budget: 0,
    spent: 0,
    actual: 0,
    accural: 0,
    invoiced: 0,
    etc: 0,
    bac: 0,
  });
  const [progressSummary, setProgressSummary] = useState({
    status: 0,
    totalCount: 0,
    progressCount: 0,
    progress: 0,
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    client: "",
    startDate: "",
    endDate: "",
    revisedEndDate: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(localStorage.getItem("isOverviewHeaderCollapsed") === "true");
  const [reportOptions, setReportOptions] = useState([
    { id: "IncludeCriticalPath", label: "Critical Path", value: true, isVisible: true },
    { id: "IncludeRisks", label: "Risks & Issues", value: true, isVisible: true },
    { id: "IncludeDecisionsLog", label: "Decisions Log", value: true, isVisible: true },
    { id: "IncludeChangeRequests", label: "Change Requests", value: true, isVisible: true },
    { id: "IncludeBudgets", label: "Budget Summary", value: true, isVisible: true },
    { id: "IncludeBudgetsForecast", label: "Forecast & Revenue Summary", value: true, isVisible: true },
    { id: "IncludeResources", label: "Resources Summary", value: true, isVisible: true },
    { id: "IncludePurchaseOrders", label: "Purchase Orders", value: true, isVisible: true },
    { id: "IncludeInvoiceRegistry", label: "Invoice Registry", value: true, isVisible: true },
    { id: "IncludeCommunicationPlans", label: "Communication Plans", value: true, isVisible: true },
    { id: "IncludeAppendix", label: "Appendix", value: true, isVisible: true },
    { id: "IncludeDetailedPlan", label: "Detailed Plan", value: true, isVisible: true },
  ]);
  const history = useHistory();
  const dispatch = useDispatch();

  const { updateTab, getSelectedTab } = useNavigation();

  const savedTab = getSelectedTab("Projects", projectID);
  const [selectedNavItem, setSelectedNavItem] = useState("details");

  const canEdit = getEditPermission("Project");
  const canDelete = getDeletePermission("Project", {isPendingDelete : data.isPendingDelete});

  /*redirections based on location state*/
  const location = useLocation();
  const [redirectionId, setRedirectionId] = useState(null);
  const [redirectionTab, setRedirectionTab] = useState(null);
  // Read URL params and set redirection state
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const rType = searchParams.get('r_t'); // redirection type (integer)
    const rId = searchParams.get('r_id'); // redirection id

    if (rType) {
      const tabName = TAB_MAPPING[parseInt(rType)];
      if (tabName) {
        setRedirectionTab(tabName);
        setSelectedNavItem(tabName);
        updateTab(tabName);
      }
    }
    else {
      setSelectedNavItem(savedTab || "details");
    }

    if (rId) {
      setRedirectionId(rId);
    }
  }, [location.search]);

  // Clear redirection state after use
  const handleRedirectionComplete = () => {
    setRedirectionId(null);
    setRedirectionTab(null);
    /*const searchParams = new URLSearchParams(location.search);
    searchParams.delete('r_t');
    searchParams.delete('r_id');
    history.replace({ search: searchParams.toString() });*/
  };

  const handleHeaderSectionState = () => {
    setIsHeaderCollapsed(!isHeaderCollapsed);
    localStorage.setItem("isOverviewHeaderCollapsed", !isHeaderCollapsed);
  }
  // Handle tab change - update both local state and Redux state
  const handleTabChange = (newTab) => {
    setSelectedNavItem(newTab);
    updateTab(newTab);
  };

  // Update tab state when navigation changes (e.g., back/forward navigation)
  useEffect(() => {
    const currentSavedTab = getSelectedTab("Projects", projectID);
    if (currentSavedTab && currentSavedTab !== selectedNavItem) {
      setSelectedNavItem(currentSavedTab);
    }
  }, [getSelectedTab, projectID, selectedNavItem]);

  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [deleteRequestModal, setDeleteRequestModal] = useState(false);
  const [deleteRequestData, setDeleteRequestData] = useState({});
  const [isDeleteRequestLoading, setIsDeleteRequestLoading] = useState(false);
  const [projectAppendices, setProjectAppendices] = useState([]);

  useEffect(() => {
    getProjectDetails({ id: projectID });
  }, []);

  useEffect(() => {
    if (error !== "") {
      error &&
        Object?.keys(error)?.forEach((key) => {
          if (key === "Name") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              name: error[key][0],
            }));
          }
          if (key === "ClientId") {
            setFormErrors((prevErrors) => ({
              ...prevErrors,
              client: error[key][0],
            }));
          }
        });
    } else {
      setFormErrors({});
    }
  }, [error]);

  const handleInputChange = (value, name) => {
    if (name === "name") {
      setName(value);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
    if (name === "client") {
      setClient(value);
      setPortfolio("");
      setProgram("");
      setManager(null);
      setLead(null);
      if (formErrors && value) {
        setFormErrors({
          ...formErrors,
          [name]: "",
        });
      }
    }
  };

  const fetchProjectData = async () => {
    setIsLoading(true);
    projectService
      .getProjectDetailsRequest({ id: projectID })
      .then((projectData) => {
        setName(projectData.name);
        setType(projectData.type);
        setStartDate(projectData.startDate);
        setEndDate(projectData.endDate);
        setRevisedEndDate(projectData.revisedEndDate);

        const clientArr = {
          value: projectData.client.id,
          label: projectData.client.name,
        };
        setClient(clientArr);
        if (projectData.portfolio) {
          const portfolioArr = {
            value: projectData.portfolio.id,
            label: projectData.portfolio.name,
          };
          setPortfolio(portfolioArr);
        }
        if (projectData.program) {
          const programArr = {
            value: projectData.program.id,
            label: projectData.program.name,
          };
          setProgram(programArr);
        }
        setExecutive(projectData.executive);
        setExecutiveId(projectData.executive?.id);
        setSponsor(projectData.sponsor);
        setSponsorId(projectData.sponsor?.id);
        setBudget(projectData.budget);
        setStatus(projectData.status);
        setRefId(projectData.refId);
        setProgress(projectData.progress);
        setManager(projectData.owner);
        setLead(projectData.lead);
        setStakeholders(projectData.stakeholders);
        setStakeholdersIds(
          projectData.stakeholders?.length > 0
            ? projectData.stakeholders.map((contact) => contact.id).join(",")
            : ""
        );
        setDescription(projectData.description);
        setAttachments(projectData.attachments || []);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsEdit(false);
        console.error("Error fetching project data:", error);
      });
  };

  useEffect(() => {
    if (isEdit) {
      fetchProjectData();
    }
  }, [isEdit]);

  const handleUpdateGLobalStatus = (data) => {
    if (data) {
      if (data.isForecast == true) {
        setTrendingGlobalHealth(data.status);
      } else {
        setCurrentGlobalHealth(data.status);
      }
    }
  };

  const handleAppendixNameChange = (appendix) => {
    setProjectAppendices((prev) =>
      prev.map((item) =>
        item.id === appendix.id ? { ...item, name: appendix.name } : item
      )
    );
  };

  const handleSelectedAppendix = (appendix) => {
    if (appendix.id === "new") {
      projectService
        .createProjectAppendixRequest(projectID)
        .then((data) => {
          setProjectAppendices((prev) => [...prev, data]);
          setSelectedAppendix(data);
        })
        .catch(() => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
        });
    } else {
      setSelectedAppendix(appendix);
    }
  };

  const handleAppendixDeleted = (appendixId) => {
    projectService
      .deleteProjectAppendixRequest({ projectId: projectID, appendixId })
      .then(() => {
        getProjectAppendencies();
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      });
  };

  const getProjectAppendencies = () => {
    projectService
      .getProjectAppendicesRequest(projectID)
      .then((data) => {
        setProjectAppendices(data);
        if (data?.length === 0)
          handleSelectedAppendix({ id: 'new' })
        else {
          var currentAppendixPresent = data.find(a => a.id === selectedAppendix?.id);
          if (!currentAppendixPresent)
            handleSelectedAppendix(data[0]);
        }
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      });
  }

  const renderSelectedComponent = () => {
    switch (selectedNavItem) {
      case "details":
        return <ProjectDetails projectData={data} />;
      case "healthStatus":
        return (
          <HealthStatus
            projectID={projectID}
            handleUpdateGLobalStatus={handleUpdateGLobalStatus}
            handleUpdatePeriod={(date) => setStatusReportPeriod(date)}
          />
        );
      case "scopeItem":
        return (
          <ScopeItem
            projectID={projectID}
            defaultProject={data}
            overviewType="Project"
          />
        );
      case "milestones":
        return (
          <Milestones
            parentData={{ id: data.id, name: data.name }}
            parentType="Project"
          />
        );
      case "changeRequest":
        return (
          <ChangeRequest
            projectID={projectID}
            defaultProject={data}
            overviewType="Project"
            redirectionId={redirectionTab === "changeRequest" ? redirectionId : null}
            onRedirectionComplete={handleRedirectionComplete}
          />
        );
      case "risk/Issues":
        return (
          <Risk
            projectID={projectID}
            defaultProject={data}
            overviewType="Project"
            redirectionId={redirectionTab === "risk/Issues" ? redirectionId : null}
            onRedirectionComplete={handleRedirectionComplete}
          />
        );
      case "decisionLog":
        return <DecisionLog projectID={projectID} />;
      case "purchaseOrders":
        return <PurchaseOrders projectID={projectID} />;
      case "invoiceRegistry":
        return <InvoiceRegistry projectID={projectID} />;
      case "allocatedResources":
        return <ResourcesReport
          parentType={ParentType.PROJECT}
          parentId={projectID} />;
      case "stakeholders":
        return <Stakeholders />;
      case "communication":
        return (
          <Communication
            projectID={projectID}
            defaultProject={data}
            overviewType="Project"
            redirectionId={redirectionTab === "communication" ? redirectionId : null}
            onRedirectionComplete={handleRedirectionComplete}
          />
        );
      case "budget":
        return (
          <Budget
            projectID={projectID}
            defaultProject={data}
            overviewType="Project"
            redirectionId={redirectionTab === "budget" ? redirectionId : null}
            onRedirectionComplete={handleRedirectionComplete}
          />
        );
      case "timeline":
        return (
          <ResourceMoniteringProvider>
            <DashboardHeader projectID={projectID} overviewType="Project" isHeaderCollapsed={isHeaderCollapsed} />
          </ResourceMoniteringProvider>
        );
      case "appendix":
        return (
          <Appendix
            parentId={projectID}
            appendix={selectedAppendix}
            onAppendixNameChange={handleAppendixNameChange}
          />
        );
      case "cashflow":
        return <CashFlow projectId={projectID} isHeaderCollapsed={isHeaderCollapsed} />;
      default:
        return <ProjectDetails projectData={data} />;
    }
  };

  const searchClientHandler = (value) => {
    if (value === "") {
      setClients([]);
      return;
    }
    service
      .searchClientDataRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClients(transformedArray);
      })
      .catch(() => {
        setClients([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolios([]);
      return;
    }
    const payload = { id: client?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (client)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolios(transformedArray);
      })
      .catch(() => {
        setPortfolios([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setPrograms([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Project";

    if (client) {
      queryParam = `?clientId=${client?.value}&searchTerm=${payload.searchText}`;
    }

    if (portfolio) {
      queryParam = `?portfolioId=${portfolio.value}&searchTerm=${payload.searchText}`;
    }

    if (client && portfolio) {
      queryParam = `?clientId=${client.value}&portfolioId=${portfolio.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPrograms(transformedArray);
      })
      .catch(() => {
        setPrograms([]);
      });
  };

  useEffect(() => {
    if (client === "") setProgram("");
  }, [client]);

  const formBody = () => {
    return (
      <>
        <div className="d-flex align-items-end justify-content-between">
          <div className={isEdit ? "col-8" : "col-12"}>
            <InputUnderline
              placeholder="Add project name"
              value={name}
              handleChange={(value) => handleInputChange(value, "name")}
              error={formErrors.name}
              isRequired
              loading={isLoading}
            />
          </div>
          {isEdit && (
            <>
              <div className="col-2 ml-2">
                <label class="Input_label">Type</label>
                <p
                  style={{ border: "1px solid #342C82", backgroundColor: type == 0 ? "#EDECF8" : "#DBEAFE", color: type == 0 ? "#342C82" : "#1E40AF" }}
                  className="text-xs font-semibold text-center py-[4px] rounded-md"
                >
                  {`${getLabelByType("projectType", type)}`}
                </p>
              </div>
              <div className="col-1 ml-1">
                <label class="Input_label">Progress</label>
                <p
                  style={{ border: "1px solid #342C82" }}
                  className="text-xs text-[#1F1F1F] font-semibold bg-[#EDECF8] text-center py-[4px] rounded-md"
                >
                  {`${progress} %`}
                </p>
              </div>
            </>
          )}
        </div>
        <div className="row gx-3 mb-3">
          <div className="col mt-4 w-100">
            <Searchable
              label="Client"
              SelectText="client"
              searchText={searchClientHandler}
              options={clients}
              defaultVal={client}
              onChange={(value) => handleInputChange(value, "client")}
              errorMessage={formErrors.client}
              isRequired
              loading={isLoading}
            />
          </div>
          <div className="col mt-4 w-100">
            <Searchable
              label="Portfolio"
              SelectText="portfolio"
              searchText={searchPortfolioHandler}
              options={portfolios}
              defaultVal={portfolio}
              onChange={(e) => {
                setPortfolio(e);
                setProgram("");
              }}
              loading={isLoading}
            />
          </div>
          <div className="col mt-4 w-100">
            <Searchable
              label="Program"
              SelectText="program"
              searchText={searchProgramHandler}
              options={programs}
              defaultVal={program}
              onChange={setProgram}
              loading={isLoading}
            />
          </div>
        </div>
        <div className="row align-items-center gx-3">
          <div className="col-3">
            <UserSelect
              refType={UserSearchRefType.Project}
              refId={projectID}
              label="Project Manager"
              buttonLabel={"Select Manager"}
              value={manager}
              onChange={setManager}
              loading={isLoading}
            />
          </div>
          <div className="col-3">
            <UserSelect
              refType={UserSearchRefType.Project}
              refId={projectID}
              label="Technical Lead"
              buttonLabel={"Select Lead"}
              value={lead}
              onChange={setLead}
              loading={isLoading}
            />
          </div>
          {!isLoading && (
            <>
              <div className="col-3">
                <div className="ModalAvatarGroup">
                  <label class="Input_label">Executive</label>
                  <ContactsSelect
                    parentType="Projects"
                    parentId={projectID}
                    isNewParent={false}
                    isMultiSelect={false}
                    confirmHandler={setExecutiveId}
                    existingSelectedContacts={
                      executive ? [...[], executive] : []
                    }
                  />
                </div>
              </div>
              <div className="col-3">
                <div className="ModalAvatarGroup">
                  <label class="Input_label">Sponsor</label>
                  <ContactsSelect
                    parentType="Projects"
                    parentId={projectID}
                    isNewParent={false}
                    isMultiSelect={false}
                    confirmHandler={setSponsorId}
                    existingSelectedContacts={sponsor ? [...[], sponsor] : []}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter reference ID"
              value={refId}
              type="text"
              handleChange={setRefId}
              label="Reference ID"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <label class="Input_label">Status</label>
            <DropDown
              label="Status"
              showLabel={false}
              options={projectStatus}
              defaultVal={getLabelByType("project", status)}
              onChange={setStatus}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <label class="Input_label">Budget</label>
            <p
              style={{ border: "1px solid #342C82" }}
              className=" text-[#1F1F1F] bg-[#EDECF8] text-center py-[4px] rounded-md"
            >
              {`${getAccountCurrency(setting)} ${displayDecimalFormatted(
                setting,
                budget
              )}`}
            </p>
          </div>
        </div>
        <div className="row align-items-center gx-3 mb-3">
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={startDate}
              maxDate={revisedEndDate ? revisedEndDate : endDate}
              type="date"
              handleChange={setStartDate}
              label="Start Date"
              errorMessage={formErrors.startDate}
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={endDate}
              minDate={startDate}
              type="date"
              handleChange={setEndDate}
              errorMessage={formErrors.endDate}
              label="End Date"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={<CalendarIcon />}
              value={revisedEndDate}
              minDate={startDate}
              type="date"
              handleChange={setRevisedEndDate}
              label="Revised End Date"
              errorMessage={formErrors.revisedEndDate}
              loading={isLoading}
            />
          </div>
        </div>
        {!isLoading && (
          <div className="row">
            <div className="col-12">
              <label class="Input_label">Stakeholders</label>
              <ContactsSelect
                parentType="Projects"
                parentId={projectID}
                isNewParent={false}
                isMultiSelect={true}
                confirmHandler={setStakeholdersIds}
                existingSelectedContacts={stakeholders}
              />
            </div>
          </div>
        )}
        <div className="row mb-3">
          <div className="col-12">
            <RichTextEditor
              label="Description"
              content={description}
              onChange={setDescription}
              loading={isLoading}
            />
          </div>
        </div>

        <EntityFileUpload
          entityId={projectID}
          entityType="Project"
          attachments={attachments}
          onAttachmentsChange={() => {
            // Refresh project data to get updated attachments
            if (projectID) {
              projectService.getProjectDetailsRequest({ id: projectID })
                .then((projectData) => {
                  setAttachments(projectData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching project data:", error);
                });
            }
          }}
          disabled={isLoading || !projectID}
        />
      </>
    );
  };

  const handleDelete = () => {
    setIsDeleteLoading(true);
    if (deleteRequest) {
      deletionRequestService
        .confirmDeletionRequest(deleteRequest.requestId)
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          history.push(`/projects`);
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    } else {
      projectService
        .deleteProjectRequest({ id: projectID })
        .then((response) => {
          setIsDeleteLoading(false);
          setDeleteModal(false);
          if (response && !response.IsDeletionAllowed) {
            setDeleteRequestData(response);
            setDeleteRequestModal(true);
          } else {
            history.goBack();
          }
        })
        .catch((err) => {
          dispatch(
            generalActions.showToast({
              title: "Something went wrong. Please try again later.",
              type: "error",
            })
          );
          setIsDeleteLoading(true);
          setDeleteModal(false);
        });
    }
  };
  const handleDeleteRequested = () => {
    getProjectDetails({ id: projectID });
  };
  const handleCancelDeleteRequest = () => {
    setIsDeleteRequestLoading(true);
    deletionRequestService
      .cancelDeletionRequest({ RefId: projectID, RefType: 3 })
      .then(() => {
        setIsDeleteRequestLoading(false);
        getProjectDetails({ id: projectID });
      })
      .catch(() => {
        setIsDeleteRequestLoading(false);
        dispatch(
          generalActions.showToast({
            title: "Something went wrong. Please try again later.",
            type: "error",
          })
        );
      });
  };

  const handleCancel = () => {
    setIsEdit(false);
    setFormErrors({});
  };

  const handleCancl = () => {
    setDeleteModal(false);
  };

  useEffect(() => {
    setData(projectData);
    if (projectData.health) {
      setCurrentGlobalHealth(projectData.health?.current);
      setTrendingGlobalHealth(projectData.health?.trending);
    }
    if (projectData.appendices) {
      setProjectAppendices(projectData.appendices);
      projectData.appendices?.length > 0 &&
        setSelectedAppendix(projectData.appendices[0]);
    }
    setBudgetSummary({
      budget: projectData.budget,
      spent: projectData.spent,
      actual: projectData.actual,
      accural: projectData.accural,
      invoiced: projectData.invoiced,
      etc: projectData.etc,
      bac: projectData.bac,
    })
    setProgressSummary(projectData.progressSummary);
  }, [projectData]);

  useEffect(() => {
    if (projectBudgetSummary) {
      setBudgetSummary(projectBudgetSummary);
    }
  }, [projectBudgetSummary]);

  useEffect(() => {
    if (projectProgressSummary) {
      setProgressSummary(projectProgressSummary);
    }
  }, [projectProgressSummary]);

  const showDeleteModal = () => {
    setDeleteModal(true);
  };

  const showEditModal = () => {
    setIsEdit(true);
  };

  const handleReportOptionToggle = useCallback((optionId, checked) => {
    setReportOptions((prev) =>
      prev.map((option) =>
        option.id === optionId
          ? { ...option, value: checked }
          : option
      )
    );
  }, []);

  const handleStatusReport = () => {
    const options = reportOptions.reduce((acc, option) => {
      acc[option.id] = option.value;
      return acc;
    }, {});

    StatusReportRequest({
      id: projectID,
      date: statusReportPeriod,
      options
    });
  };

  const reportModalCloseHandler = () => {
    dispatch(clearReportRequest());
    setShowStatusReport(false);
  };

  useEffect(() => {
    if (getReport) {
      const pdfBlob = new Blob([getReport], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(pdfBlob);
      setPdfData(blobUrl);
      setShowStatusReport(true);
    }
  }, [getReport, getReportLoading]);

  const handleSave = () => {
    const payload = {
      name,
      startDate,
      endDate,
      revisedEndDate,
      ProgramId: program && program?.value,
      executiveId,
      sponsorId,
      status,
      refId,
      OwnerId: manager?.id,
      leadId: lead?.id,
      description,
      stakeholders: stakeholdersIds,
      ClientId: client && client?.value,
      PortfolioId: portfolio?.value,
    };
    const errors = {};
    if (!name) errors["name"] = `The Name field is required.`;
    if (!client) errors["client"] = `ClientId is required.`;
    if (startDate && endDate && isDateGreaterThan(startDate, endDate)) {
      errors[
        "endDate"
      ] = `End date must be equal to or greater than start date.`;
    }
    if (
      startDate &&
      revisedEndDate &&
      isDateGreaterThan(startDate, revisedEndDate)
    ) {
      errors[
        "revisedEndDate"
      ] = `Revised end date must be equal to or greater than start date.`;
    }
    setFormErrors(errors);
    if (Object?.keys(errors)?.length) {
      return;
    }
    updateProjectRequest({ id: data.id, type: "overview", payload });
  };

  useEffect(() => {
    if (!loading) {
      setIsEdit(false);
    }
  }, [loading]);

  useEffect(() => {
    if (program && !manualUpdate.current.portfolio) {
      if (!client && !portfolio) {
        programService
          .fetchProgramDataRequest({ id: program.value })
          .then((data) => {
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            data.client
              ? setClient({ label: data.client.name, value: data.client.id })
              : setClient("");
            data.portfolio
              ? setPortfolio({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolio("");
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      }
    }
  }, [program]);

  useEffect(() => {
    if (!portfolio) {
      setProgram("");
    }
    if (portfolio && !manualUpdate.current.client) {
      if (!client) {
        portfolioService
          .getPortfolioDetails({ id: portfolio.value })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClient({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClient("");
            setProgram("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgram("");
        }
      }
    }
  }, [portfolio]);

  useEffect(() => {
    if (!client) {
      setPortfolio("");
      setProgram("");
    }
    if (client && prevClientId.current === null) {
      prevClientId.current = client.value;
    }

    if (client && prevClientId.current !== client.value) {
      setPortfolio("");
      setProgram("");
      prevClientId.current = client.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [client]);

  useEffect(() => {
    if (deleteRequest) {
      setDeleteModal(true);
    }
  }, [deleteRequest]);

  return (
    <div className="projectOverviewScreen relative">
      {overviewLoading ?
        (
          <div className={styles.overviewHeaderWrapper}>
            <div
              className={`${styles.overviewHeadingWrap} d-flex justify-content-between align-items-start`}
            >
              <div className="d-flex align-items-start gap-1 flex-col">
                <Skeleton
                  height={30}
                  width={250}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
                <Skeleton
                  height={25}
                  width={200}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
                <Skeleton
                  height={20}
                  width={150}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              </div>
              <div className="d-flex align-items-center gap-3 flex-col">
                <Skeleton
                  height={30}
                  width={250}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
                <Skeleton
                  height={20}
                  width={200}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              </div>
              <div className="d-flex align-items-end gap-4 flex-col">
                <Skeleton
                  height={30}
                  width={250}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
                <Skeleton
                  height={20}
                  width={200}
                  baseColor="#e0e0e0"
                  highlightColor="#ECE7FD"
                />
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <Skeleton
                height={25}
                width={250}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
              <Skeleton
                height={25}
                width={250}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
              <Skeleton
                height={25}
                width={250}
                baseColor="#e0e0e0"
                highlightColor="#ECE7FD"
              />
            </div>
          </div>
        ) :
        !isHeaderCollapsed &&
        (
          <div className={styles.overviewHeaderWrapper}>
            <div
              className={`${styles.overviewHeadingWrap} d-flex justify-content-between align-items-center`}
            >
              {projectData && (
                <div className="d-flex align-items-center">
                  {projectData?.client?.image && (
                    <div className="flex flex-col items-center justify-center max-w-32 h-14 overflow-hidden">
                      <img
                        src={projectData?.client?.image}
                        alt="Project Client"
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>
                  )}
                  <h4 className="ms-3 heading22">{projectData.name}</h4>
                  {data.isPendingDelete && (
                    <span className="pill purple m-2">Pending Delete</span>
                  )}
                </div>
              )}
              {projectData && (
                <>
                  <div className="flex justify-center" style={{ zIndex: 0 }}>
                    <ProjectProgress
                      progress={progressSummary}
                    />
                  </div>
                  <div className="flex justify-center">
                    <BudgetChart
                      budgetSummary={budgetSummary}
                      currencySymbol={getAccountCurrency(setting)}
                      className={"overview-budget-chart"}
                    />
                  </div>
                </>
              )}

              <div className="d-flex align-items-center">
                <Menu positioning="below-end">
                  <MenuTrigger disableButtonEnhancement>
                    {(triggerProps) => (
                      <SplitButton
                        menuButton={{
                          ...triggerProps,
                          menuIcon: <Settings2 color="#342c82" size={12} />,
                          className: `${styles.reportMenuButton}`,
                        }}
                        primaryActionButton={{
                          className: `${styles.reportPrimaryButton}`,
                          onClick: handleStatusReport,
                          disabled: getReportLoading,
                        }}
                        icon={
                          <ProjectGlobalStatus
                            health={{
                              current: currentGlobalHealth,
                              trending: trendingGlobalHealth,
                            }}
                          />
                        }
                        disabled={getReportLoading}

                      >
                        <div className="flex col gap-2 align-items-center justify-content-end ml-4">
                          {getReportLoading ?
                            (<>
                              <Spinner
                                className="me-1"
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                              Loading...
                            </>) :
                            (<>
                              <PrintIcon />
                              Status Report
                            </>)
                          }
                        </div>

                      </SplitButton>
                    )}
                  </MenuTrigger>

                  <MenuPopover className={styles.reportOptionsPopover}>
                    <MenuList className={styles.reportOptionsList}>
                      {reportOptions
                        .filter((option) => option.isVisible)
                        .map((option) => (
                          <MenuItem
                            key={option.id}
                            className={styles.reportOptionItem}
                            disabled={getReportLoading}
                            persistOnClick={true}
                          >
                            <div
                              className={styles.reportOptionContent}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleReportOptionToggle(option.id, !option.value);
                              }}
                            >
                              <span>
                                {option.label}
                              </span>
                              <Switch
                                checked={option.value}
                                onChange={(ev, data) => {
                                  ev.stopPropagation();
                                  handleReportOptionToggle(option.id, data.checked);
                                }}
                                className={`${styles.reportOptionSwitch} ToggleStyle`}
                              />
                            </div>
                          </MenuItem>
                        ))}
                    </MenuList>
                  </MenuPopover>
                </Menu>
                <div className={styles.overviewCustomBtn}>
                  {data.isPendingDelete ? (
                    <Button
                      label="Cancel Delete Request"
                      icon={
                        <span className="icons20">
                          <ClipboardX />
                        </span>
                      }
                      clickHandler={handleCancelDeleteRequest}
                      showLoading={isDeleteRequestLoading}
                      btnClass={`${styles.actionButton} ${styles.noRightBorder}`}
                    />
                  ) : (
                    canDelete && (
                      <Button
                        label="Delete"
                        icon={
                          <span className="icons20">
                            <DeleteIcon color="#342c82" />
                          </span>
                        }
                        clickHandler={() => showDeleteModal()}
                        btnClass={`${styles.actionButton} ${canEdit ? styles.noRightBorder : ""}`}
                      />
                    )
                  )}
                  {
                    canEdit && (
                      <Button
                        label="Edit"
                        icon={
                          <span className="icons20">
                            <EditIcon color="#342c82" />
                          </span>
                        }
                        clickHandler={() => showEditModal()}
                        btnClass={`${styles.actionButton} ${canDelete ? styles.noLeftBorderRadius: ''}`}
                      />
                    )
                  }
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">Created by</p>
                <div className="d-flex align-items-center">
                  {projectData.creator && (
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={projectData.creator.name}
                          image={{
                            src: projectData.creator.image
                              ? projectData.creator.image
                              : "",
                          }}
                          color="colorful"
                        />
                      }
                      AvatarId={projectData.creator.id}
                      AvatarName={projectData.creator.name}
                      AvatarImage={projectData.creator.image}
                      AvatarDesignation={projectData.creator.title}
                      AvatarEmail={projectData.creator.email}
                      AvatarPhone={projectData.creator.phoneNumber}
                      AvatarIsExternal={projectData.creator.isExternal}
                    />
                  )}
                  <p className="text-md-500 ms-1 BaseMainColor">
                    {projectData.creator ? projectData.creator.name : "--"}
                  </p>
                </div>
              </div>
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">
                  Project Manager
                </p>
                <div className="d-flex align-items-center">
                  {projectData.owner && (
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={projectData.owner.name}
                          image={{
                            src: projectData.owner.image
                              ? projectData.owner.image
                              : "",
                          }}
                          color="colorful"
                        />
                      }
                      AvatarId={projectData.owner.id}
                      AvatarName={projectData.owner.name}
                      AvatarImage={projectData.owner.image}
                      AvatarDesignation={projectData.owner.title}
                      AvatarEmail={projectData.owner.email}
                      AvatarPhone={projectData.owner.phoneNumber}
                      AvatarIsExternal={projectData.owner.isExternal}
                    />
                  )}
                  <p className="text-md-500 ms-1 BaseMainColor">
                    {projectData.owner ? projectData.owner.name : <>&nbsp;</>}
                  </p>
                </div>
              </div>
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">
                  Technical Lead
                </p>
                <div className="d-flex align-items-center">
                  {projectData.lead && (
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={projectData.lead.name}
                          image={{
                            src: projectData.lead.image
                              ? projectData.lead.image
                              : "",
                          }}
                          color="colorful"
                        />
                      }
                      AvatarId={projectData.lead.id}
                      AvatarName={projectData.lead.name}
                      AvatarImage={projectData.lead.image}
                      AvatarDesignation={projectData.lead.title}
                      AvatarEmail={projectData.lead.email}
                      AvatarPhone={projectData.lead.phoneNumber}
                      AvatarIsExternal={projectData.lead.isExternal}
                    />
                  )}
                  <p className="text-md-500 ms-1 BaseMainColor">
                    {projectData.lead ? projectData.lead.name : <>&nbsp;</>}
                  </p>
                </div>
              </div>
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">
                  Project Sponsor
                </p>
                <div className="d-flex align-items-center">
                  {projectData.sponsor && (
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={
                            projectData.sponsor
                              ? projectData.sponsor?.name ||
                              projectData.sponsor?.email ||
                              projectData.sponsor?.phone
                              : "--"
                          }
                          image=""
                          color="colorful"
                        />
                      }
                      AvatarName={projectData.sponsor?.name || projectData.sponsor?.email || projectData.sponsor?.phone}
                      AvatarDesignation="Sponsor"
                      AvatarEmail={projectData.sponsor?.email}
                      AvatarPhone={projectData.sponsor?.phone}
                      AvatarIsExternal={true}
                      CanSendMessage={false}
                    />
                  )}
                  <p className="text-md-500 ms-1 BaseMainColor">
                    {projectData.sponsor
                      ? projectData.sponsor?.name ||
                      projectData.sponsor?.email ||
                      projectData.sponsor?.phone
                      : <>&nbsp;</>}
                  </p>
                </div>
              </div>
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">Client Manager</p>
                <div className="d-flex align-items-center">
                  {projectData.client?.manager && (
                    <HoverCard
                      HoverCardTrigger={
                        <Avatar
                          size={28}
                          name={
                            projectData.client?.manager
                              ? projectData.client.manager?.name ||
                              projectData.client.manager?.email ||
                              projectData.client.manager?.phone
                              : "--"
                          }
                          image=""
                          color="colorful"
                        />
                      }
                      AvatarName={projectData.client?.manager?.name || projectData.client?.manager?.email || projectData.client?.manager?.phone}
                      AvatarDesignation="Manager"
                      AvatarEmail={projectData.client?.manager?.email}
                      AvatarPhone={projectData.client?.manager?.phone}
                      AvatarIsExternal={true}
                      CanSendMessage={false}
                    />
                  )}
                  <p className="text-md-500 ms-1 BaseMainColor">
                    {projectData.client?.manager
                      ? projectData.client.manager?.name ||
                      projectData.client.manager?.email ||
                      projectData.client.manager?.phone
                      : <>&nbsp;</>}
                  </p>
                </div>
              </div>
              <div className={styles.overviewAvatarWrapper}>
                <p className="text-sm-400 BaseSecondColor mb-6">Project Start / End date</p>
                {projectData.startDate || projectData.revisedEndDate || projectData.endDate ?
                  <span className="text-md-500 BaseMainColor">
                    {`${projectData.startDate ? dateOnlyFormatted(setting, projectData.startDate) : "-"}
                 to 
                 ${projectData.revisedEndDate || projectData.endDate ? dateOnlyFormatted(setting, projectData.revisedEndDate || projectData.endDate) : "-"}`}
                  </span>
                  :
                  <span className="text-md-500 BaseMainColor">-</span>
                }
              </div>
            </div>
          </div>
        )
      }

      <div className={isHeaderCollapsed ? "pt-3" : ''}>
        <Tabs
          selectedTab={selectedNavItem}
          setSelectedTab={handleTabChange}
          setSelectedProjectAppendix={handleSelectedAppendix}
          onProjectAppendixDelete={handleAppendixDeleted}
          type="projects"
          projectID={projectID}
          projectAppendices={projectAppendices}
        />
      </div>
      {deleteModal && (
        <Modal
          title={`Delete project`}
          body={
            <p className="text-sm-400 subHeading-color">{`Are you sure you want to delete the project?`}</p>
          }
          handleCancel={() => handleCancl()}
          handleSave={() => handleDelete()}
          saveBtnLabel="Delete"
          cancelBtnLabel="Cancel"
          isLoading={isDeleteLoading}
        />
      )}
      {deleteRequestModal && (
        <DeleteRequest
          data={deleteRequestData}
          handleCancel={setDeleteRequestModal}
          handleRefresh={() => handleDeleteRequested()}
        />
      )}
      {isEdit && (
        <Modal
          title={`Edit ${projectData.name}`}
          handleCancel={() => handleCancel()}
          handleSave={() => handleSave()}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={loading}
          size="large"
          body={formBody()}
        />
      )}
      <section
        className="TabsContentSection"
        style={{
          height: isHeaderCollapsed ? "calc(100vh - 218px)" : null,
        }}
      >
        {renderSelectedComponent()}
      </section>
      {showStatusReport && (
        <Modal
          title={`${data.name} - Weekly Status Report`}
          handleCancel={reportModalCloseHandler}
          body={
            pdfData && (
              <iframe
                title="PDF Viewer"
                src={pdfData}
                width="100%"
                height="100%"
              ></iframe>
            )
          }
          type={true}
          size=""
        />
      )}
      {!overviewLoading &&
        (
          <div className={styles.overviewHeaderCollapseButton} onClick={handleHeaderSectionState}>
            <Tooltip content={isHeaderCollapsed ? "Expand" : "Collapse"} relationship="label" positioning="before">
              {isHeaderCollapsed ? <ListChevronsUpDown size={20} /> : <ListChevronsDownUp size={20} />}
            </Tooltip>
          </div>
        )}
    </div>
  );
};
export default ProjectOverview;

const ProjectGlobalStatus = ({ health }) => {
  return (
    <div className="flex justify-center align-items-center gap-2 mx-5">
      <HealthKPISquare status={health.current} />
      <HealthKPIArrow status={health.trending} />
    </div>
  );
};
